import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { ResultList } from "../area/ResultList";
import { SearchCondition } from "../area/SearchCondition";
import { Area } from "../area/Area";
import { area_selector } from "../../common/area_selector";
import masterData from "../../lib/masterData";
import PropTypes from "prop-types";
import Accordion from "semantic-ui-react/dist/commonjs/modules/Accordion";
import { conditionString } from "../../lib/masterUtil";

export class AreaSelect extends Area {
  static contextTypes = {
    router: PropTypes.object,
  };
  toggleSearch = () => {
    this.setState({
      activeIndex: this.state.activeIndex ? null : 1,
    });
  };
  goToSearch = () => {
    document.getElementById('searchArea').scrollIntoView({
      behavior: "smooth",
      block: "start",
    })
  }
  getScrollTarget() {
    // 検索後は、同一コンポネントの地図のないページなので、物件リストの最初にスクロールする
    return this.refs.searchResult || this;
  }
  render() {
    const type = this.props.type;
    const params = this.props.match.params;
    const pref = params.pref ? masterData.pref.bySlug[params.pref] : null;
    if(pref){
      //document.title = `${pref.name}でトランクルームをお探しなら『ハローストレージ${pref.name}』`;
    }else{
      //document.title = `トランクルームをお探しなら『ハローストレージ』【公式】`;
    }
    if ("全部屋から検索" === conditionString(this.state.value, pref && pref.prefId)) {
    return (
      <div className="container">
        {(() => {
            return breadcrumbs(type, [
              {
                text: "検索結果",
              },
            ]);
        })()}
        
        <div className="content">
          <div className="control">
            <div className="title">
              {(() => {
                if (pref) {
                  return (
                    <span>
                      <span className="area_name">{pref.name}</span>
                      のトランクルームを探す
                    </span>
                  );
                }
              })()}
            </div>
            <div className="search_cont">
              <div className="serach_header">
                <div className="title">検索条件</div>
                <div className="conditions">
                  {conditionString(this.state.value, pref && pref.prefId)}
                </div>
                <div onClick={this.goToSearch}className="btn">条件を変更する</div>
              </div>
              <div className="search_cont_dtl">
                <SearchCondition
                  {...{ type }}
                  value={this.state.value && this.state.value.condition}
                  onSearch={value => {
                    this.onClickSearchButton({ condition: value });
                  }}
                />
              </div>
            </div>
          </div>
          <div ref="searchResult" />
          <ResultList
            {...{
              type,
              list: this.state.list,
              resetScroll: this.resetScroll,
            }}
          />
        </div>
      </div>
    );
    } else {
    return (
      <div className="container">
        {(() => {
            return breadcrumbs(type, [
              {
                text: "検索結果",
              },
            ]);
        })()}
        
        <div className="content">
          <div className="control">
            <div className="title">
              {(() => {
                if (pref) {
                  return (
                    <span>
                      <span className="area_name">{pref.name}</span>
                      のトランクルームを探す
                    </span>
                  );
                }
              })()}
            </div>
            <div className="search_cont">
              <Accordion>
                <Accordion.Title
                  active={this.state.activeIndex === 1}
                  index={1}
                  onClick={this.toggleSearch}
                >
                  <div className="serach_header">
                    <div className="title">検索条件</div>
                    <div className="conditions">
                      {conditionString(
                        this.state.value,
                        pref && pref.prefId
                      )}
                    </div>
                    <div className="btn">条件を変更する</div>
                  </div>
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 1}>
                  <div className="search_cont_dtl">
                    <SearchCondition
                      {...{ type }}
                      value={this.state.value && this.state.value.condition}
                      onSearch={value => {
                        this.onClickSearchButton({ condition: value });
                      }}
                    />
                  </div>
                </Accordion.Content>
              </Accordion>
            </div>
          </div>
          <div ref="searchResult" />
          <ResultList
            {...{
              type,
              list: this.state.list,
              resetScroll: this.resetScroll,
            }}
          />
        </div>
      </div>
    );
    }
  }
}



// WEBPACK FOOTER //
// ./pages/area_select/AreaSelect.jsx